// To keep the log a manageable length, please limit the number of releases listed here to 5.
// If you are adding a 6th entry, please remove the oldest entry so that the total remains at 5.

const VersionLog = `

### Version 5.17.0 - September 1, 2026

- No user-facing changes. Using new GEM endpoint for obtaining calendars to enable capturing of event data.

---

### Version 5.16.0 - August 12, 2026

- Guest creation and updates now trigger notifications to other Sono Bello systems.
- No user-facing changes.  Updates SSO login endpoint to support updating the logged in user in InContact.

---

### Version 5.15.1 - July 13, 2026

- Fixes bug where the Bad Lead disposition on the Search step would not end or disposition Digital contacts.

---

### Version 5.15.0 - July 06, 2026

- No user-facing changes. Adds support for the new InContact update to 'digital first omnichannel'. This should allow the dispositions in MAX for SMS/Chat/Email contacts to continue to be automatically set when completing the Disposition step in GEM.

---

### Version 5.14.4 - June 10, 2026

- Update identity provider to support SSO after Zenoti migration to Azure.

`;

export default VersionLog;
